import { Helmet } from "react-helmet-async";

const BASE_URL = "https://phoonmusic.com";
const DEFAULT_IMAGE = `${BASE_URL}/api/files/phoon-site/uploads/c89d905c-a1fb-4262-91b8-8f04d35b1545.jpg`;

export default function SEO({ title, description, path = "/", image }) {
  const fullTitle = title ? `${title} — PHÖÖN` : "PHÖÖN — House & Tech House DJ / Producer";
  const desc = description || "Phöön is a house and tech house DJ and producer based in Chicago. Bookings, music, live sets, and press inquiries.";
  const url = `${BASE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
